export enum EventFormat {
  SINGLE_SESSION = 'SINGLE_SESSION',
  MULTI_SESSION = 'MULTI_SESSION',
  SERIES = 'SERIES',
}
